export const arrayToQs = (key, arr) => arr.map((v) => `${key}=${v}`).join('&')

export default 0
